export function jornadaLocationNotice(platform) {
    return platform === 'android'
        ? 'Durante la jornada se registra la ubicación del dispositivo, también en segundo plano. El registro se detiene al finalizar.'
        : 'Durante la jornada se registra la ubicación del dispositivo mientras mantenés la app abierta. El registro se detiene al finalizar.';
}

export function jornadaStatusLabel(shift, busy) {
    if (busy) return 'Verificando jornada…';
    if (shift.gpsError || (shift.active && shift.gpsStatus !== 'ready')) return 'Revisar jornada';
    return shift.active ? 'En curso' : 'Inactiva';
}
